import { render } from "./GridTabParteneriComercial.vue?vue&type=template&id=3e14ae4e&scoped=true&ts=true"
import script from "./GridTabParteneriComercial.vue?vue&type=script&lang=ts"
export * from "./GridTabParteneriComercial.vue?vue&type=script&lang=ts"

import "./GridTabParteneriComercial.vue?vue&type=style&index=0&id=3e14ae4e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e14ae4e"]])

export default __exports__